import { render, staticRenderFns } from "./apartment-price-view-switch.vue?vue&type=template&id=30a0f240&scoped=true&"
import script from "./apartment-price-view-switch.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-view-switch.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-view-switch.scss?vue&type=style&index=0&id=30a0f240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0f240",
  null
  
)

export default component.exports